import { FC } from 'react';
import { useCountdownTimer } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';

interface PromoGameTimerProps {
  dateEnd?: number;
}

export const PromoGameTimer: FC<PromoGameTimerProps> = ({ dateEnd }) => {
  const { t } = useTranslation();
  const { days, minutes, seconds, hours } = useCountdownTimer(dateEnd);
  const timeLeft = { days, hours, minutes, seconds };

  return (
    <div className="flex justify-start items-center">
      {Object.entries(timeLeft).map(([date, value]) => {
        if (date === 'days') return null;
        return (
          <p key={date} className="text-sm lowercase text-gb_promo_banner_timer_text">
            {value}
            {t(`general.${date}`)}
            &nbsp;{date !== 'seconds' && ':'}&nbsp;
          </p>
        );
      })}
    </div>
  );
};
